<template>
  <body id="app">
    <b-container fluid>
      <DemandFunnel
        uncentered
        :title="this.substituteText(header_title)"
        :subtitle="this.substituteText(header_subtitle)"
        :level_1_text="this.substituteText(level_1_text)"
        :level_2_text="this.substituteText(level_2_text)"
        :level_3_text="this.substituteText(level_3_text)"
        :level_4_text="this.substituteText(level_4_text)"
      />
    </b-container>

    <component :is="'style'" lang="css" v-text="themeCSS"></component>
  </body>
</template>

<script>
import Vue from "vue"

import "@/filters.js"

import BootstrapVue from "bootstrap-vue"
Vue.use(BootstrapVue)

Vue.prototype.$ = require('jquery')

Vue.config.productionTip = false

// Global components
import GraphLoader from '@/components/loaders/Graph.vue'
Vue.component('VGraphLoader', GraphLoader)

import DemandFunnel from "@/components/generic/DemandFunnel"
import store from "@/store/index"
import { mapGetters } from 'vuex'

export default {
  name: "buyside-state-funnel",
  store,
  components: {
    DemandFunnel
  },
  computed: {
    ...mapGetters('config', ['themeCSS']),
    textReplaceMap() {
      const map = {
        '#state#'                 : this.value_state                  || undefined,
        '#propertyaddress#'       : this.value_property_address       || undefined,
        '#from_price#'            : this.$options.filters.formatPrice(this.value_from_price) || undefined,
        '#to_price#'              : this.$options.filters.formatPrice(this.value_to_price)   || undefined,
        '#bedroom_count#'         : this.value_bedroom_count          || undefined,
        '#buyer_matches_interval#': this.value_buyer_matches_interval || undefined,
      };

      return map;
    }
  },
  methods: {
    substituteText(input) {
      let string = input
      const map = this.textReplaceMap

      Object.entries(map).forEach(([key, newval]) => {
        string = string.replace(new RegExp(key, 'g'), newval)
      })

      return string
    }
  },
  props: {
    value_state: {
      // This is the value that will be substituted in for the keyword "#state#" in the funnel level text
      type: String,
      required: true
    },
    value_property_address: {
      // This is the value that will be substituted in for the keyword "#propertyaddress#" in the funnel level text
      type: String,
      required: true
    },
    value_from_price: {
      // This is the value that will be substituted in for the keyword "#from_price#" in the funnel level text
      type: Number,
      required: true,
      validator(value) {
        const test = !Number.isNaN(Number(value)) &&
                      value >= 0
        if(!test)
          console.error("An invalid numeric value has been supplied for <buyside-state-funnel>'s prop 'value_from_price'")

        return test
      }
    },
    value_to_price: {
      // This is the value that will be substituted in for the keyword "#to_price#" in the funnel level text
      type: Number,
      required: true,
      validator(value) {
        const test = !Number.isNaN(Number(value)) &&
                      value >= 0
        if(!test)
          console.error("An invalid numeric value has been supplied for <buyside-state-funnel>'s prop 'value_to_price'")

        return test
      }
    },
    value_bedroom_count: {
      // This is the value that will be substituted in for the keyword "#bedroom_count#" in the funnel level text
      type: Number,
      required: true,
      validator(value) {
        const test = !Number.isNaN(Number(value)) &&
                      value >= 0
        if(!test)
          console.error("An invalid numeric value has been supplied for <buyside-state-funnel>'s prop 'value_bedroom_count'")

        return test
      }
    },
    value_buyer_matches_interval: {
      // This is the value that will be substituted in for the keyword "#buyer_matches_interval#" in the funnel level text
      type: Number,
      required: true,
      validator(value) {
        const test = !Number.isNaN(Number(value)) &&
                      value >= 0 &&
                      Number.isInteger(Number(value))
        if(!test)
          console.error("An invalid numeric value has been supplied for <buyside-state-funnel>'s prop 'value_buyer_matches_interval'")

        return test
      }
    },

    level_1_text: {
      type: String,
      required: true
    },
    level_2_text: {
      type: String,
      required: true
    },
    level_3_text: {
      type: String,
      required: true
    },
    level_4_text: {
      type: String,
      required: true
    },

    header_title: {
      type: String,
      required: false
    },
    header_subtitle: {
      type: String,
      required: false
    },
    address: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    zipcode: {
      type: String,
      required: true
    },
    brokerage_id: {
      type: Number,
      required: true
    },
    agent_id: {
      type: Number,
      required: true
    }
  },
  async created() {

    this.$store.commit('config/loadingConfig', false)

    const addressObj = {
      address1: this.address,
      address2: null,
      city    : this.city,
      state   : this.state,
      zipcode : this.zipcode
    };
    this.$store.commit('listing/setAddress', addressObj)

    this.$store.commit('listings/loadingListing', false)

    this.$store.cache.dispatch("buyers/getFunnel", {
      address: addressObj,
      brokerage_id: this.brokerage_id,
      agent_id: this.agent_id
    })
    .then   ( response  => this.$store.commit('buyers/setFunnel', response) )
    .catch  ( er        => console.error(er) )
    .finally( ()        => this.$store.commit('buyers/loadingFunnel', false) )
  }
}
</script>

<style lang="scss">
@import "@/styles/custom.scss";
#app {
  //font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
